module.exports = __webpack_public_path__ + "static/img/home_development_tools.6cb6170.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/home_development_tools.png
// module id = 1399
// module chunks = 1